package org.ssoft.common.type

import org.ssoft.common.tools.calculateAspectRatio

@Suppress("ClassName")
sealed class AspectRatio(
    var mask: Int,
    val pair: Pair<Int, Int>,
    val label: String = "${pair.first} : ${pair.second}",
    val pairAlter: Pair<Int, Int> = pair,
) {
    data object NONE : AspectRatio(0, -1 to -1, "NONE")
    data object _2_1 : AspectRatio(2, 2 to 1)
    data object _3_2 : AspectRatio(4, 3 to 2)
    data object _4_3 : AspectRatio(8, 4 to 3)
    data object _5_4 : AspectRatio(16, 5 to 4)
    data object _16_9 : AspectRatio(32, 16 to 9)
    data object _16_10 : AspectRatio(64, 16 to 10, pairAlter = 8 to 5)
    data object _21_9 : AspectRatio(128, 21 to 9, pairAlter = 7 to 3)
    data object _1_1 : AspectRatio(256, 1 to 1, pairAlter = 1 to 1)


    infix fun match(mask: Int): Boolean = (this.mask and mask) > 0

    companion object {
        val all by lazy {
            listOf(_2_1, _3_2, _4_3, _5_4, _16_9, _16_10, _21_9, _1_1)
        }

        val allWithNone by lazy {
            listOf(NONE) + all
        }

        //
        operator fun get(mask: Int): List<AspectRatio> {
            return allWithNone.filter { (mask and it.mask) > 0 }
        }

        operator fun get(ratio: Pair<Int, Int>): AspectRatio? {
            return ratio.let {
                val reversed = ratio.second to ratio.first
                all.firstOrNull {
                    it.pair == ratio || it.pairAlter == ratio
                            || it.pair == reversed || it.pairAlter == reversed
                }
            }
        }

        suspend fun calculate(width: Int, height: Int): AspectRatio? = this[calculateAspectRatio(width, height)]
    }
}